<script>
  export default {
    name: "AtomStatusButton",
    props: {
      status: {
        type: String,
        default: "pencil",
      },
    },
    computed: {
      ariaLabel() {
        const map = {
          pencil: "Editar",
          save: "Guardar",
          loading: "Guardando…",
          success: "Guardado",
        };
        return map[this.status] || "Estado";
      },
    },
  };
</script>

<template>
  <button :class="[`status-btn--${status}`, 'status-btn']" @click="$emit('click')" :aria-label="ariaLabel">
    <iconic :class="`atomIconic-btn--${status}`" :name="status" />
  </button>
</template>

<style lang="scss" scoped>
  .status-btn {
    width: 20px;
    height: 20px;
    @include Flex(row, center, center);
    border: none;
    border-radius: 3.87px;

    transition: background-color 0.25s ease, border-color 0.25s ease;
    cursor: pointer;

    &--saved,
    &--loading {
      background-color: #c61111;
      border-color: #c61111;
    }

    &--success {
      background-color: #21b329;
      border-color: #21b329;
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
